import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';
// Import Swiper and modules
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { ScrollSmoother } from '../vendor/gsap/ScrollSmoother';
import smoov from '../util/smooth-scroll';
import itsMobile from '../util/is-mobile';

// Swiper.use([Navigation, Pagination]);
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

smoov();

const native = $('.native-state');
const slider = $('.swiper-state');
const copyWrap = $('.culture-copy-box .copy-wrap');
const content = $('.swiper-card-content');
const region = $('#photo-deck');
const icon = $('.btn.js-btn-plus-close .toggle-icon');
const toggleBtn = $('.js-btn-plus-close');
const lgOffset = '53vw';
const appTl = gsap.timeline();
const closeAppTl = gsap.timeline();
const panelCopyTl = gsap.timeline({ paused: true });
const mobileMaxHeight = 'squareSide';
const mobileSliderCardWidth = 'squareSide';
const lgSliderCardWidth = 'clamp(460px, 40vw, 460px)';
const lgMaxHeight = '400px';
const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
const lgMediaQuery = window.matchMedia('(min-width: 768px)');
let imgSlider;

gsap.registerPlugin(ScrollTrigger, CustomEase);

// Sub functions

// Fade out left side paragraph
panelCopyTl
    .to(copyWrap, {
        x: -160, duration: 0.8, opacity: 0, ease: 'power2.out',
    }).reverse();

function dropCopyBox() {
    panelCopyTl.reversed(!panelCopyTl.reversed());
}

// Expand maxHeight of slider panel
function panelHeightExpand() {
    gsap.to(slider, {
        duration: 0.6,
        ease: 'linear',
        maxHeight: '780px',
        onStart: () => {
            $(slider).addClass('activated');
        },
    }, '0');
}

// Card width
function renderWidth() {
    let w = lgSliderCardWidth;
    if (mobileMediaQuery.matches) {
        gsap.set('.native-state .photo-card', { clearProps: 'width' });
        w = `${mobileSliderCardWidth}px`;
    } else {
        gsap.to('.native-state .photo-card', { clearProps: 'all' });
    }

    return w;
}

// Reducing maxHeight of slider panel
function panelHeightRetract() {
    gsap.set($('.native-state'), { clearProps: 'marginTop' });
    $(slider).removeClass('activated');

    const maxHeightTl = gsap.timeline();

    // If mobile set maxheight to native height
    if (mobileMediaQuery.matches) {
        maxHeightTl.to(slider, {
            duration: 1,
            maxHeight: mobileMaxHeight,
        });
    } else {
        maxHeightTl.to(slider, {
            duration: 0.7,
            ease: 'linear',
            maxHeight: lgMaxHeight,
        });
    }

    return maxHeightTl;
}

// Toggle button left align
function positionToggleBtn() {
    if (lgMediaQuery.matches) {
        const refPoint = $('.culture-copy-box').offset();
        const btnPos = refPoint.left - 12;
        gsap.to(toggleBtn, {
            duration: 0.4,
            ease: 'power4.out',
            left: `${btnPos}px`,
            onComplete: () => {
                $(toggleBtn).removeClass('native-aligned');
            },
        });
    } else {
        gsap.set(toggleBtn, { clearProps: 'left' });
    }
}

// Photo positioning
function alignPhotos() {
    $('.native-state').removeClass('collapsed');

    const align = gsap.utils.toArray('.swiper-slide').forEach((item) => {
        const thisImg = $(item).attr('data-photo-pos');
        const offset = $(item).offset();
        const leftEdge = offset.left;
        const pos = $(item).position();
        const posLeft = pos.left;
        const matchedCard = $(`.native-state .photo-card[data-photo-pos="${thisImg}"]`);
        const cardWidth = matchedCard.width();

        // Set the card to a pixel width for a smoother tween
        $(matchedCard).css('width', `${cardWidth}px`);

        if (mobileMediaQuery.matches) {
            // Mobile flyout
            const mobileCardTl = gsap.timeline();
            mobileCardTl.to(matchedCard, {
                x: '0%',
                left: '0',
                transform: 'none',
            });

            mobileCardTl.to(matchedCard, {
                width: mobileSliderCardWidth,
                x: '0%',
                left: `${posLeft}px`,
            });
        } else {
            // Desktop flyout
            gsap.to(matchedCard, {
                rotation: '0deg',
                width: `${cardWidth}px`,
                x: 0,
            });

            gsap.to(matchedCard, {
                duration: 0.6,
                ease: CustomEase.create('custom', 'M0,0 C0.292,0.002 0.234,0.564 0.434,0.84 0.53,0.972 0.81,1 1,1 '),
                width: '460px',
                x: `${leftEdge}px`,
            });
        }
    });

    return align;
}

// Align native-state photos in the background when slider updates
function alignPhotosFast() {
    const fastAlign = gsap.utils.toArray('.swiper-slide').forEach((item) => {
        if (lgMediaQuery.matches) {
            const thisImg = $(item).attr('data-photo-pos');
            const position = $(item).offset();
            const leftEdge = position.left;
            const matchedCard = $(`.native-state .photo-card[data-photo-pos="${thisImg}"]`);

            gsap.to(matchedCard, { x: `${leftEdge}px` }).progress(1);
        }
    });

    return fastAlign;
}

// Seamless switch to slider after card flyout
function appReady() {
    appTl.clear();
    appTl.to(slider, {
        visibility: 'visible',
        zIndex: 1,
    })
        .fromTo(content, {
            y: 50,
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            duration: 0.7,
            stagger: 0.1,
        }, '0')
        .to(native, {
            visibility: 'hidden',
            zIndex: -1,
        }, '.8')
        .to('.swiper-card .photo-card', {
            visibility: 'visible',
        }, '.7');

    return appTl;
}

// Reset back to native state and hide slider
function appClose() {
    closeAppTl.clear();
    closeAppTl.to(native, {
        visibility: 'visible',
        zIndex: 1,
    }, '0').to(slider, {
        visibility: 'hidden',
        zIndex: -1,
    }, '0')
        .to(content,
            { y: 50, opacity: 0 })
        .to('.swiper-card .photo-card', {
            visibility: 'hidden',
        }, '0');

    return closeAppTl;
}

// Make the cards return to their stacked-deck state
function cardsReturn() {
    // Write mobile for here
    if (mobileMediaQuery.matches) {
        gsap.utils.toArray('.native-state .photo-card').forEach((item) => {
            gsap.to(item, {
                x: '-50%',
                left: '50%',
                duration: 0.8,
                ease: 'power4.out',
                width: renderWidth(),
                clearProps: 'left, x, width',
            });
        });
        // Return mobile to slide 1
        imgSlider.slideTo(0);
    } else {
        gsap.utils.toArray('.native-state .photo-card').forEach((item) => {
            gsap.to(item, {
                x: lgOffset,
                left: 0,
                duration: 0.8,
                ease: 'power4.out',
                width: renderWidth(),
                clearProps: 'all',
            });
        });
    }

    $(region).addClass('collapsed');
}

// Revert plus button
function revertBtn() {
    if (lgMediaQuery.matches) {
        gsap.to(toggleBtn, {
            delay: 0.3,
            duration: 0.9,
            ease: 'power4.out',
            left: `calc(${lgOffset} - 25px)`,
            clearProps: 'left',
            onStart: () => {
                $('.native-state').removeClass('hover');
            },
            onComplete: () => {
                $(toggleBtn).addClass('native-aligned').removeClass('close-ready');
            },
        });
    } else {
        $(toggleBtn).addClass('native-aligned').removeClass('close-ready');
    }
}
function checkWidth() {
    if ($(toggleBtn).hasClass('close-ready')) {
        positionToggleBtn();
    } else {
        gsap.set(toggleBtn, { clearProps: 'left' });
        gsap.set('.native-state .photo-card', {
            clearProps: 'all',
        });
    }
}
// Main resize function
function ccResize() {
    checkWidth();
}

// Master timeline functions
function collapseTimeline() {
    const collapseMaster = gsap.timeline();
    collapseMaster.add(alignPhotosFast());
    collapseMaster.add(panelHeightRetract, 0);
    collapseMaster.add($('.native-state.collapsed').removeClass('hover'), 0);
    collapseMaster.add($(region).attr('aria-expanded', 'false'), 0);
    collapseMaster.add($(icon).removeClass('open'), 0);
    collapseMaster.add(revertBtn, 0.1);
    collapseMaster.add(dropCopyBox, 0.1);
    collapseMaster.add(appClose, 0.1);
    collapseMaster.add(cardsReturn, 0.1);

    return collapseMaster;
}

// Revert on close
function resetPhotos() {
    collapseTimeline();
}

// Flyout master timeline
function expandTimeline() {
    const expandMaster = gsap.timeline();
    expandMaster.add($(toggleBtn).attr('aria-expanded', 'true'), 0);
    expandMaster.add($(region).attr('aria-expanded', 'true'), 0);
    expandMaster.add($('.native-state').removeClass('collapsed'), 0);
    expandMaster.add($(icon).addClass('open'), 0);
    expandMaster.add($(toggleBtn).addClass('close-ready'), 0);
    expandMaster.add(positionToggleBtn, 0);
    expandMaster.add(alignPhotos, 0);
    expandMaster.add(panelHeightExpand, 0);
    expandMaster.add(dropCopyBox, 0.1);
    expandMaster.add(appReady, 0.3);

    return expandMaster;
}

function expandToSlider() {
    expandTimeline();
}

function expandToggle(e) {
    e.preventDefault();

    if ($(region).attr('aria-expanded') === 'false') {
        expandToSlider();
    } else {
        resetPhotos();
    }
}

$(toggleBtn).on('click', (e) => {
    expandToggle(e);
});

// Plus button toggle hover for non-mobile only
if (!itsMobile()) {
    $(toggleBtn).on('mouseover', (e) => {
        if (!$(e.currentTarget).hasClass('close-ready')) {
            $(e.currentTarget).addClass('hover');
            $('.native-state.collapsed').addClass('hover');
        }
    }).on('mouseout', (e) => {
        $(e.currentTarget).removeClass('hover');
        $('.native-state.collapsed').removeClass('hover');
    });
}

$(window).on('resize', () => {
    ccResize();
});

// Culture Careers Slider
export default function ccSlider() {
    // Progress function
    function translateVal(el) {
        const progress = el.style.transform.match(/translate3d\((.+)px,(.+)px,(.+)px\)/);
        return progress[1];
    }
    imgSlider = new Swiper('.cc-slider', {
        modules: [Navigation, Pagination, Scrollbar],
        scrollbar: {
            freeMode: {
                enabled: true,
                sticky: false,
            },
            simulateTouch: true,
            grabCurser: true,
            el: '.slider-scrollbar',
            draggable: true,
            snapOnRelease: false,
            dragSize: 30,
        },
        pagination: { // dots
            el: '.swiper-pagination',
            clickable: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            640: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            992: {
                spaceBetween: 40,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            sliderMove(swiper, event) {
                $('.cursor').css({
                    transform: `translate3d(${event.clientX}px, ${event.clientY}px, 0px)`,
                });
            },
            setTranslate() {
                if ($(this.scrollbar.dragEl).length > 0) {
                    const progress = translateVal(this.scrollbar.dragEl);
                    $('.slider-progress2').css('width', `${progress}px`);
                }
            },
            slideChangeTransitionEnd() {
                if ($(this.scrollbar.dragEl).length > 0) {
                    const progress = translateVal(this.scrollbar.dragEl);
                    $('.slider-progress2').css('width', `${progress}px`);
                }

                alignPhotosFast();
            },
        },
    });

    return imgSlider;
}
